import React from 'react';
import './FlagLayers.css';
import {
  FIELD_FLAG,
  FIELD_FLAG_REST_LAYERS,
  FIELD_FLAG_TEXTURE_PATHS,
  FIELD_FLAG_TEXTURE_TRIMS,
} from '../../../configs/fieldFlags';
import {getPlayerHexColor} from '../../../utils/players/getPlayerHexColor';

// Сторона значка в точках картинки жетона: quarter_base шириной 500 точек вписан в
// квадрат значка. Кадр флага лежит по центру жетона в тех же точках — как на поле
const ICON_SIDE_PX = 500;
const FRAME_OFFSET_PX = (ICON_SIDE_PX - FIELD_FLAG.frameSize) / 2;

const toIconPercent = (px) => `${(px / ICON_SIDE_PX) * 100}%`;

const LAYERS = FIELD_FLAG_REST_LAYERS.map(({textureKey, isTinted}) => {
  const {x, y, width, height} = FIELD_FLAG_TEXTURE_TRIMS[textureKey];
  const imageUrl = `url('${FIELD_FLAG_TEXTURE_PATHS[textureKey]}')`;
  return {
    textureKey,
    isTinted,
    imageUrl,
    position: {
      left: toIconPercent(x + FRAME_OFFSET_PX),
      top: toIconPercent(y + FRAME_OFFSET_PX),
      width: toIconPercent(width),
      height: toIconPercent(height),
      backgroundImage: imageUrl,
    },
  };
});

// Неподвижный флаг из тех же слоев, что и на поле (scenes/FieldFlags): ткань серая
// умножается на цвет игрока, как setTint у спрайта, а маска оставляет ее форму.
// Заполняет родителя с position: relative и масштабируется вместе с ним
const FlagLayers = ({color}) => (
  <>
    {LAYERS.map(({textureKey, isTinted, imageUrl, position}) => (
      <div
        key={textureKey}
        className={'flag-layer'}
        style={isTinted ? {
          ...position,
          backgroundColor: getPlayerHexColor(color),
          backgroundBlendMode: 'multiply',
          maskImage: imageUrl,
          WebkitMaskImage: imageUrl,
        } : position}
      />
    ))}
  </>
);

export default FlagLayers;
